import safeFetch from '../../utils/safeFetch';
import getQuoteIdFromUrl from './getQuoteIdFromUrl';

const getCartFromUrl = (url, requestData) => {
  return new Promise((resolve, reject) => {
    getQuoteIdFromUrl(window.getQuoteIdUrl)
      .then((quoteId) => {
        safeFetch(url, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...requestData, quoteid: quoteId }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      })
      .catch((error) => reject(error));
  });
};

export default getCartFromUrl;
